import styled from "styled-components";

export const FooterContainer = styled.footer`
  font-family: "Pretendard";
  padding: 0;
  font-size: 18px;
  height: 350px;
  margin-top: 100px;
  .content {
    width: 100%;
    max-width: 1440px;
    padding: 0 20px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
  .info {
    margin-bottom: 30px;
    img {
      max-width: 200px;
      max-height: 100px;
      object-fit: contain;
    }
  }
  .list {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    ul {
      max-width: 30%;
      li {
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &.theme-0 {
    background: #fff;
    border-top: 1px solid #000;
    box-sizing: border-box;
    color: #000;
  }
  &.theme-2 {
    height: 300px;
    background: #222222;
    color: #fff;
    display: flex;
    align-items: center;
    .info img {
      max-width: 150px;
      max-height: 75px;
    }
    .content {
      max-width: 1240px;
      flex-direction: row;
      align-items: flex-start;
      height: auto;
      gap: 100px;
    }
    .list {
      width: calc(100% - 250px);
      font-size: 16px;
    }
  }
  &.theme-4 {
    background: #000;
  }
  @media screen and (max-width: 1050px) {
    font-size: 16px;
  }
  @media screen and (max-width: 767px) {
    margin-top: 50px;
    font-size: 12px;
    height: auto;
    padding: 40px 0;
    .info {
      img {
        max-width: 100px;
        max-height: 50px;
      }
    }
    .list {
      flex-direction: column;
      ul {
        margin-bottom: 10px;
        width: 100%;
        max-width: 100%;
        &:last-child {
          margin-bottom: 0;
        }
        li {
          margin-bottom: 10px;
        }
      }
    }
    &.theme-2 {
      height: auto;
      .content {
        flex-direction: column;
        gap: 30px;
      }
      .list {
        width: 100%;
      }
    }
  }
`;
